import { info } from '../utils/logger';

const requestTimes: number[] = [];

export const MASSIVE_MAX_RPM = Number(import.meta.env?.VITE_MASSIVE_MAX_RPM ?? 3);

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const runWithMassiveRateLimit = async <T,>(
    fn: () => Promise<T>,
    context?: { label?: string }
): Promise<T> => {
    while (true) {
        const now = Date.now();
        while (requestTimes.length && now - requestTimes[0] > 60_000) requestTimes.shift();
        if (requestTimes.length < MASSIVE_MAX_RPM) {
            requestTimes.push(now);
            return fn();
        }

        const wait = 60_000 - (now - requestTimes[0]) + 50;
        const waitSeconds = Math.ceil(wait / 1000);
        const label = context?.label ? ` (${context.label})` : '';
        info(`Massive rate limit reached${label}. Queuing request for ~${waitSeconds}s.`);
        await sleep(Math.max(50, wait));
    }
};
